<template>
  <v-chip
    :color="chipColor"
    :text-color="textColor"
    x-small
    label
  >
    {{ chipLabel }}
  </v-chip>
</template>

<script>
const ACTION_MAP = {
  created: { label: 'Создано', color: 'info' },
  updated: { label: 'Обновлено', color: 'primary' },
  approved: { label: 'Одобрено', color: 'success' },
  rejected: { label: 'Отклонено', color: 'error' },
  activated: { label: 'Активировано', color: 'success' },
  expired: { label: 'Истекло', color: 'warning' },
  deleted: { label: 'Удалено', color: 'error' },
}

export default {
  name: 'BenefitLogActionChip',
  props: {
    action: {
      type: String,
      default: '',
    },
  },
  computed: {
    meta() {
      return ACTION_MAP[this.action] || { label: this.action || '—', color: 'default' }
    },
    chipColor() {
      return this.meta.color
    },
    chipLabel() {
      return this.meta.label
    },
    textColor() {
      const map = {
        info: 'white', primary: 'white', success: 'white', error: 'white', warning: 'white',
      }
      return map[this.meta.color] || undefined
    },
  },
}
</script>
